import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  programItemHeader: {
    display: 'flex',
    justifyContent: 'flex-end',
  },

  programItemWrapper: {},
  programItemForm: {
    width: '100%',
  },

  infoDataWrapper: {
    marginTop: theme.spacing(1),
  },

  programSetsContainer: {
    marginTop: theme.spacing(1),
  },

  programSetWrapper: {
    marginTop: theme.spacing(2),
  },
  programItemFooter: {
    padding: theme.spacing(2, 0),
  },

  addProgramSetFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
}));
